import { createContext, useContext } from "react";

export const TooltipVisibilityContext = createContext<boolean>(true);

export const useTooltipVisibility = () => useContext(TooltipVisibilityContext);
